import { Injectable, InjectionToken, Inject, Optional, Type } from '@angular/core';
import {
  SgClickConfirmPlugin,
  SgClickConfirmPlugins,
  SgClickConfirmOptions,
  SgClickConfirmPluginContext,
} from './types';

/**
 * A provider token for default settings for SgClickConfirmModule
 */
export const SG_CLICK_CONFIRM_DEFAULTS = new InjectionToken('SG_CLICK_CONFIRM_DEFAULTS');

/**
 * A Multi provider token for click confirm style plugins
 */
export const SG_CLICK_CONFIRM_PLUGIN = new InjectionToken('SG_CLICK_CONFIRM_PLUGIN');

@Injectable()
export class SgClickConfirmPluginHost {
  private pluginStore = new Map<keyof SgClickConfirmPlugins, SgClickConfirmPlugin>();

  constructor(
    @Inject(SG_CLICK_CONFIRM_DEFAULTS) private defaultOptions: SgClickConfirmOptions,
    @Optional() @Inject(SG_CLICK_CONFIRM_PLUGIN) private plugins: SgClickConfirmPlugin[]
  ) {
    if (plugins) {
      for (let p of plugins) {
        this.register(p);
      }
    }
  }

  // plugin<P extends keyof SgClickConfirmPlugins>(plugin: P): SgClickConfirmPlugins[P] {
  plugin(plugin: keyof SgClickConfirmPlugins): SgClickConfirmPlugin {
    const p = this.pluginStore.get(plugin);
    if (!p) {
      throw new Error(`Invalid click confirm style "${plugin}"`);
    }
    return p;
  }

  /**
   * Register the plugin.
   * This should not be used directly, use provider configuration intead.
   *
   * ```
   *   { provide: SG_CLICK_CONFIRM_PLUGIN, useClass: SgClickConfirmPopoverPlugin, multi: true },
   * ```
   */
  register(plugin: SgClickConfirmPlugin): void {
    this.pluginStore.set(plugin.name, plugin);
  }

  createContext(ctx: SgClickConfirmPluginContext): SgClickConfirmPluginContext {
    const options: SgClickConfirmOptions = Object.assign({}, this.defaultOptions, ctx.options);
    const component: Type<any> = options.component || this.defaultOptions.component; // if by accident was set to null/undefined etc...
    const newCtx: SgClickConfirmPluginContext = Object.assign({}, ctx, { options, component });
    return newCtx;
  }
}
